import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import PrimarySidebarItem from "./PrimarySidebarItem";
import FAIcon from "../UI/FAIcon/FAIcon";
const windowMdSize = 768;
const isAboveMedium = () => window.innerWidth > windowMdSize;
const getStorageName = () => {
    const matches = window.location.pathname.match(/aviso\/(.*?)\/(.*?)(\/|\?|#|$)/);
    // @ts-expect-error - TS2531 - Object is possibly 'null'. | TS2531 - Object is possibly 'null'.
    return "p-nav-" + matches[1] + "-" + matches[2];
};
const setInLocalStorage = (isOpen) => {
    localStorage.setItem(getStorageName(), isOpen ? "open" : "closed");
};
export const PrimarySidebarHeader = (props) => {
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "p-sidebar-header", children: [_jsxs("span", { className: "p-sidebar-header-title-holder", children: [props.setIsOpen && (_jsxs("button", { type: "button", className: "btn btn-link p-sidebar-toggle-button empty-btn-link", title: "Toggle Sidebar", 
                            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                            onClick: () => props.setIsOpen(), children: [_jsx(FAIcon, { icon: "bars" }), _jsx("span", { className: "sr-only", children: "Toggle Sidebar" })] })), _jsx("h6", { className: classNames("p-sidebar-header-title p-sidebar-hide-on-close", { "ml-3": !props.setIsOpen }), children: props.title })] }), props.secondaryButton] }) }));
};
const renderSidebar = (props, setIsOpen) => {
    const { menu, title, sidebar, secondaryButton } = props;
    if (menu) {
        const sidebarMenu = menu.map((item, index) => (_jsx(PrimarySidebarItem, Object.assign({}, item), index)));
        const sidebarHeader = title ? (_jsx(PrimarySidebarHeader, { title: title, 
            // @ts-expect-error - TS2322 - Type '(isOpen: boolean) => void' is not assignable to type '(isOpen?: boolean | null | undefined) => void | null | undefined'.
            setIsOpen: setIsOpen, secondaryButton: secondaryButton })) : null;
        return (_jsxs(_Fragment, { children: [sidebarHeader, sidebarMenu] }));
    }
    // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2345 - Argument of type '(isOpen: boolean) => void' is not assignable to parameter of type '(arg1?: boolean | null | undefined) => void'.
    return sidebar(setIsOpen);
};
const PrimarySidebarLayout = (props) => {
    // Initialize state with the value in local storage.
    const [_isOpen, _setIsOpen] = React.useState(false);
    const [isMediumOpen, setIsMediumOpen] = React.useState(localStorage.getItem(getStorageName()) !== "closed");
    const isOpen = _isOpen || (isAboveMedium() && isMediumOpen);
    const setIsOpen = (open) => {
        // If open is undefined, set it to the opposite of the current value.  This makes it easy to toggle the open state.
        const calcOpen = open == null ? !isOpen : open;
        if ((isOpen && calcOpen) || (!isOpen && !calcOpen)) {
            // Don't do anything.  No change.
            return;
        }
        if (!calcOpen) {
            setIsMediumOpen(false);
            _setIsOpen(false);
            setInLocalStorage(false);
        }
        else if (isAboveMedium()) {
            setIsMediumOpen(calcOpen);
            setInLocalStorage(calcOpen);
        }
        else {
            _setIsOpen(calcOpen);
            setInLocalStorage(calcOpen);
        }
    };
    return (_jsxs("div", { className: `p-sidebar-wrapper p-sidebar-wrapper-${props.sidebarSize} ${_isOpen ? "open" : ""} ${isMediumOpen ? "open-md" : ""}`, children: [_jsx("div", { role: "presentation", className: "p-sidebar-overlay", onClick: () => setIsOpen(false) }), _jsx("div", { className: `p-sidebar p-sidebar-${props.sidebarSize} bg-light custom-scrollbar`, children: renderSidebar(props, setIsOpen) }), typeof props.children === "function"
                ? props.children(isOpen, setIsOpen)
                : props.children] }));
};
export default PrimarySidebarLayout;
